/**
 * File: formatQuestion.js
 * Project: educore
 * Created Date: 2018-01-18
 * Author: Raziya S
 * Screen : 
 */
class FormatQpController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, archiveService, $timeout,CONSTANTS, TPWIZARDCONSTANT) {
        this.writeNote = false;
        this.scope = $scope
        this.state = $state

        let academics = localStorageService.get('authoringData')
        let userId = localStorageService.get('user_id')
        if (academics === undefined)
            $state.go('dashboard')
        let activityId = $state.params.resourceId 
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Activity"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.loadData()

        }
        self = this;
        $scope.sectionName = ""
        $scope.sectionName = ""
        $scope.sectionInstruction = ""
        $scope.markForEach = 0
        $scope.attendQues = 0
        $scope.allQues = 0
        $scope.time = []
        $scope.sectionInstruction = ""
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
         $scope.fileUrl=PREVIEW_URL
        $scope.formatQuestion = []
        //$scope.tempData = $location.protocol() + "://" + $location.host() + ":4000"

        //   $scope.qpTitle = ""
        $scope.sectionQuestions = []
        $scope.sectionWiseQuestions = []

        $scope.hours = []
        for (var hour = 0; hour <= 12; hour++) {
            hour = hour > 9 ? hour : "0" + hour;
            $scope.hours.push(hour);
        }

        $scope.minutes = []
        for (var min = 0; min < 60; min++) {
            min = min > 9 ? min : "0" + min;
            $scope.minutes.push(min);
        }

        let MQ = MathQuill.getInterface(2);
        let redirectDetails = archiveService.getRedirectJson();
        archiveService.clearRedirectJson();

        
        if (redirectDetails && redirectDetails.returnData) {
            if (redirectDetails.activeTab == "question") {
                let questions = [];
                _.each(redirectDetails.returnData, function(questionArchive) {
                    questions.push(questionArchive.resource._id)
                })
                academics['ques_ids'] = questions
                academics['activity_id'] = activityId
                authService.callAPI(TPWIZARDCONSTANT.API_SELECT_QUESTION, "POST", academics, (response) => {
                    if (response.result && response.result && response.result.data) {
                       $scope.loadData()
                    }
                })
            }
        }
        let qpDet = {
            "activity_id": activityId,
            "teacher_id": userId,
            "school_id": academics.school_id
        }
        $scope.questionType = activityCons.QUESTION_TYPE_DETAILS
        $scope.loadData=()=>{
            authService.callAPI(TPWIZARDCONSTANT.API_GET_FORMAT_QP, "POST", qpDet, (response) => {
                if (response.result && response.result.status && response.result.data.data) {
                    let result = response.result.data.data[0]
                    $scope.sectionFormat = []
                    $scope.practice_qn = result.basic_details[0].practice_qn
                    $scope.qpId = result.basic_details[0]._id
                    $scope.planId = result.basic_details[0].teaching_plan_id
                    if (result.temp_sections && result.temp_sections.length > 0)
                        $scope.formatQuestion.allQuestions = result.temp_sections
                    if (result.sections && result.sections.length > 0)
                        $scope.sectionWiseQuestions = result.sections
                    _.each($scope.formatQuestion.allQuestions, function(data, index) {
                        data.color = getColor(index);
                    })
                    if (result.basic_details[0].time) {
                        $scope.hour = result.basic_details[0].time.hour
                        $scope.min = result.basic_details[0].time.min
                    }/*
                    academics['theme_id']  = result.basic_details[0].theme_id
                    academics['user_id']  = userId
                    academics['id']  = result.basic_details[0]._id
                    academics['qp_title']  = result.basic_details[0].question_paper_title*/
                    localStorageService.set('theme_id', result.basic_details[0].theme_id)
                    $scope.$apply()
    
                    $scope.goToArchive = () => {
    
                        let searchFilters = [];
                        let authoring = academics
                        searchFilters.push({
                            type: 'curriculum',
                            value: {
                                _id: authoring.curriculum_id,
                                name: authoring.curriculum
                            },
                            deletable: false,
                            visible: false
                        });
                        searchFilters.push({
                            type: 'class',
                            value: {
                                _id: authoring.class_id,
                                name: authoring.class
                            },
                            deletable: false,
                            visible: false
                        });
                        searchFilters.push({
                            type: 'subject',
                            value: {
                                _id: authoring.subject_id,
                                name: authoring.subject
                            },
                            deletable: false,
                            visible: false
                        });
                        searchFilters.push({
                            type: "tab",
                            value: {
                                _id: "question",
                                name: "Questions"
                            },
                            deletable: false,
                            visible: false
                        });
                        let details = {
                            searchFilters: searchFilters,
                            previousState: {
                                state: 'formatQp',
                                params: $state.params
                            },
                            isMultiSelect: true,
                            isPractice: $scope.practice_qn,
                            activeTab: "question",
                            resourceType: {
                                _id: "question",
                                name: "Questions"
                            },
                        }
                        archiveService.setRedirectJson(details)
                        localStorageService.set('academicDetails', academics)
                        $state.go("archives")
                    }
    
                }
            })
        }
       

        //})

        /*
         * Function to delete question from qp
         * 
         * @question : Object - Details of question
         * 
         * @return : Null
         *
         */
        $scope.deleteQuestion = (questionId, sectionId) => {

            var confirm = $mdDialog.confirm()
                .textContent('Do you want to delete this question?')
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {

                let obj = {
                    qp_id: $scope.qpId,
                    question_id: questionId,
                    section_id: sectionId
                }
                authService.callAPI(TPWIZARDCONSTANT.API_DELETE_QUESTION, "POST", obj, function(response) {
                    if (response.result) {
                        //Number - Count of section without questions
                        let secEmptyCount = 0;

                        _.each($scope.formatQuestion.allQuestions, function(section, index) {

                            //Number - index of question which need to be removed
                            let quesIndex = section.questions.findIndex(i => i._id === questionId);
                            if (quesIndex !== -1) {
                                section.questions.splice(quesIndex, 1)
                            }
                            if (section.questions.length === 0) {
                                secEmptyCount++;
                            }
                        })
                        toastr.success("Question deleted Successfully")
                            //  if no questions, redirect to create page by varun 8-8-2018
                        if (secEmptyCount === $scope.formatQuestion.allQuestions.length) {
                            $state.go("activityForm", {
                                resourceId: activityId
                            })
                        }
                        $scope.$apply();
                    } else {
                        console.log("error : " + response.error)
                        console.log(response.error)
                    }
                })
            }, function() {});
        }

        /*
         * Function to edit question from qp
         * 
         * @question : Object - Details of question
         * 
         * @return : Null
         *
         */
        $scope.editQuestion = (question) => {
                localStorageService.set("createQuesiton", {
                    state: "tpActivity",
                    qp_id: $scope.qpId,
                    question_id: question._id,
                    activity_id: activityId,
                    theme_id: question.theme_id,
                    class_id: academics.class_id,
                    curriculum_id: academics.curriculum_id,
                    subject_id: academics.subject_id,
                    batch_id: academics.batch_id,
                    session_id: academics.session_id,
                    school_id: academics.school_id,
                    practice_qn: $scope.practice_qn,
                    academic_year: localStorageService.get("activeAcdYear"),
                    isQuestionAvailable: true,
                    teaching_plan_id:$scope.planId
                })
                $state.go("createTpQuestion")

            }
            /*
             * Function to auto format qp
             * 
             * @return : Null
             *
             */
        $scope.autoformat = () => {
            //String - Name of the theme
            let obj = {
                activity_id: activityId,
                user_id: userId,
                temp_sections: angular.copy($scope.formatQuestion.allQuestions)
            }
            authService.callAPI(TPWIZARDCONSTANT.API_AUTO_FORMAT, "POST", obj, function(response) {
                if (response.result) {
                    $state.go('tpActivityPreview', {
                        qpId: $scope.qpId
                    })
                } else {
                    console.log("error : " + response.error)
                    console.log(response.error)
                }
            })
        }

        $scope.onSetPolicy = () => {
            if ($scope.attendQues > $scope.allQues)
                $scope.attendQues = $scope.allQues
        }
        $scope.changeStatus = (status) => {
            if (status) {
                $scope.isIndividualMark = true
                $scope.allQues = $scope.sectionFormat.length
                $scope.attendQues = $scope.allQues
                    //Fixed bug #6220
                    //Developer- Raziya
                if ($scope.sectionFormat) {
                    _.each($scope.sectionFormat, function(eachQues) {
                        if (isNaN(eachQues.qn_mark))
                            eachQues.qn_mark = undefined
                    })
                }
            } else {
                $scope.isIndividualMark = false
            }
        }


        $scope.moveQuestion = function(eachQues, index) {
            let questData = []
            _.each($scope.formatQuestion.allQuestions, function(sections) {
                if (sections.name == eachQues.type) {
                    if (index > -1) {
                        sections.questions.splice(index, 1);
                        $scope.sectionFormat.push(eachQues)
                        $timeout(function() {
                            $scope.formatToLatex()
                        });
                    }
                }
            })
            $scope.allQues = $scope.sectionFormat.length
            $scope.attendQues = $scope.allQues
        }


        $scope.moveFromSection = function(eachQues, index) {
            let questData = $scope.sectionFormat[index]
            let isTypeExists = false
            if (!$scope.formatQuestion.allQuestions)
                $scope.formatQuestion.allQuestions = [];
            if ($scope.formatQuestion.allQuestions.length > 0) {
                _.each($scope.formatQuestion.allQuestions, function(sections) {
                    if (sections.name == eachQues.type) {
                        sections.questions.push(questData)
                        isTypeExists = true
                    }
                })
            }
            if (!isTypeExists) {
                let secIndex = $scope.formatQuestion.allQuestions.length;
                let newSection = {
                    name: eachQues.type,
                    questions: [questData],
                    color: getColor(secIndex)
                }
                $scope.formatQuestion.allQuestions.push(newSection)
            }
            if (index > -1) {
                $scope.sectionFormat.splice(index, 1);
            }
            $timeout(function() {
                $scope.formatToLatex()
            });
            $scope.allQues = $scope.sectionFormat.length // to get total question in each section
            $scope.attendQues = $scope.allQues
            let total = 0;
            if ($scope.allQues === 0) {
                $scope.markForEach = 0
                $scope.sectionName = ""
                $scope.sectionInstruction = ""
            }
            let obj = {
                activity_id: activityId,
                is_practice: $scope.practice_qn,
                user_id: userId,
                time: {
                    hour: $scope.hour,
                    min: $scope.min
                },
                total_mark: total,
                //total_questions: totalQuestions,
                sections: angular.copy($scope.sectionWiseQuestions),
                temp_sections: angular.copy($scope.formatQuestion.allQuestions)
            }
            // authService.callAPI(TPWIZARDCONSTANT.API_SAVE_SECTION, "POST", obj, (response) => {
            //     if (response.result && response.result) {
            //     }
            // })
            
        }

        $scope.moveFromCreatedSection = function(eachQues, index) {
                if ($scope.sectionFormat && $scope.sectionFormat.length > 0)
                    toastr.error("You have already selected one section")
                else {
                    $scope.sectionData = angular.copy($scope.sectionWiseQuestions)
                    $scope.sectionFormat = eachQues.questions
                    $scope.sectionName = eachQues.name;
                    $scope.sectionInstruction = eachQues.instruction;
                    $scope.attendQues = eachQues.mandatory_no;
                    $scope.allQues = eachQues.questions.length;
                    $scope.markForEach = eachQues.mark_each_qn;
                    if (eachQues.mark_each_qn > 0)
                        $scope.checkStatus = false
                    else
                        $scope.checkStatus = true
                    $scope.changeStatus($scope.checkStatus)
                    $scope.sectionWiseQuestions.splice(index, 1)
                    $timeout(function() {
                        $scope.formatToLatex()
                    });
                }

            }
            //To cancel editing section 
        $scope.closeSection = function() {
            if ($scope.sectionData.length > 0 && $scope.sectionFormat.length > 0)
                $scope.sectionWiseQuestions = $scope.sectionData
            $scope.errors = {}
            $scope.sectionName = ""
            $scope.sectionInstruction = ""
            $scope.markForEach = 0
            $scope.attendQues = 0
            $scope.allQues = 0
            $scope.checkStatus = false
            $scope.changeStatus($scope.checkStatus)
            $scope.sectionFormat = []
        }
        $scope.createSection = function() {
            $scope.errors = {};
            let error = false
            if ($scope.sectionName === undefined || $scope.sectionName === "") {
                $scope.errors['sectionName'] = "section name is required";
                error = true
            }
            if ($scope.sectionInstruction === undefined || $scope.sectionInstruction === "") {
                $scope.errors['sectionInstruction'] = "instruction is required";
                error = true
            }
            if ($scope.sectionFormat.length === 0) {
                $scope.errors['selectQuestion'] = "Please select atleast one question";
                error = true
            }
            if (!$scope.isIndividualMark) {
                if ($scope.markForEach === undefined || $scope.markForEach === "") {
                    $scope.errors['markForEach'] = "Enter mark for each question";
                    error = true

                }
                if ($scope.markForEach == 0) {
                    $scope.errors['markForEach'] = "Mark should be greater than 0";
                    error = true
                }
                //To save mark to each question
                if ($scope.markForEach > 0) {
                    _.each($scope.sectionFormat, function(eachQues) {
                        eachQues.qn_mark = $scope.markForEach
                    })
                }
            }

            if ($scope.isIndividualMark) {
                //Bug  #6132 -start
                $scope.markForEach = 0
                    //Bug  #6132 -end

                _.each($scope.sectionFormat, function(eachQues) {
                    if (eachQues.qn_mark) {
                        if (eachQues.qn_mark == 0) {
                            eachQues['qn_mark_error'] = true
                            toastr.error("Mark should be greater than 0")
                            error = true
                        } else
                            eachQues['qn_mark_error'] = false

                    }
                    if (!eachQues.qn_mark || eachQues.qn_mark === null || eachQues.qn_mark === undefined || eachQues.qn_mark === "") {
                        eachQues['qn_mark_error'] = true
                        toastr.error("Please enter mark for all questions")
                        error = true
                    } else
                        eachQues['qn_mark_error'] = false
                })
            }
            $scope.sectionFormat['is_individual_mark'] = $scope.checkStatus
            if ($scope.attendQues === undefined || $scope.attendQues === "") {
                $scope.errors['attendQues'] = "Enter policy";
                error = true
            }
            if ($scope.attendQues === 0) {
                $scope.errors['markForEach'] = "Please add atleast one question"
                error = true
            }
            _.each($scope.sectionWiseQuestions, function(section) {
                if (section.name === $scope.sectionName) {
                    $scope.errors['sectionName'] = "Section name already exsits";
                    error = true;
                }
            })
            if (!error) {
                $scope.sectionWiseQuestions.push({
                        'name': $scope.sectionName,
                        'instruction': $scope.sectionInstruction,
                        'mark_each_qn': $scope.markForEach,
                        'mandatory_no': $scope.attendQues,
                        'qn_no': $scope.allQues,
                        'questions': $scope.sectionFormat
                    })
                let obj = {
                    activity_id: activityId,
                    is_practice: $scope.practice_qn,
                    user_id: userId,
                    time: {
                        hour: $scope.hour,
                        min: $scope.min
                    },
                    sections: angular.copy($scope.sectionWiseQuestions),
                    temp_sections: angular.copy($scope.formatQuestion.allQuestions)
                }
                authService.callAPI(TPWIZARDCONSTANT.API_SAVE_SECTION, "POST", obj, (response) => {
                    if (response.result && response.result) {
                    }
                })
                $scope.sectionFormat = []
                $scope.sectionName = ""
                $scope.sectionInstruction = ""
                $scope.markForEach = 0
                $scope.attendQues = 0
                $scope.allQues = 0
                $scope.checkStatus = false
                $scope.changeStatus($scope.checkStatus)
            }
        }

        var calIndex = function(index, length) {
            if (index >= length) {
                if ((index - length) >= length)
                    return calIndex(index - length, length)
                else
                    return index - length;
            } else
                return index;
        }

        var getColor = (index) => {
            var colorArr = ['#2ab4c0', '#1bbc9b', '#f3c200', '#e7505a'];
            var i = calIndex(index, colorArr.length);
            return colorArr[i];
        }
        _.each($scope.formatQuestion.allQuestions, function(data, index) {
                data.color = getColor(index);
            })
            // $scope.formatQuestion.addedQuestions = [];
        $scope.toggleExpansion = function(accordianData, data, index) {
            _.each(accordianData, function(data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !data.expanded;
            })
            $scope.formatToLatex()
        }

        $scope.formatToLatex = function() {
            $timeout(function() {
                var questionElements = document.getElementsByClassName('question_desc')
                _.each(questionElements, function(spanElement) {
                    MQ.StaticMath(spanElement);
                })
                var choiceElements = document.getElementsByClassName('choice-desc')
                _.each(choiceElements, function(spanElement) {
                    MQ.StaticMath(spanElement);
                })
            }, 1000)
        }


        $scope.preview = function() {
            let obj = {
                activity_id: activityId,
                user_id: userId,
                is_practice: $scope.practice_qn,
                time: {
                    hour: $scope.hour,
                    min: $scope.min
                },
                sections: angular.copy($scope.sectionWiseQuestions) ? angular.copy($scope.sectionWiseQuestions) : [],
                temp_sections: $scope.formatQuestion.allQuestions ? angular.copy($scope.formatQuestion.allQuestions) : []
            }
            $scope.errors = {};
            let error = false
            if ($scope.hour === undefined || $scope.hour === "" || $scope.min === undefined || $scope.min === "") {
                if (!$scope.practice_qn) {
                    $scope.errors['time'] = "Time is required";
                    error = true
                }
            }
            if ($scope.sectionFormat && $scope.sectionFormat.length > 0) {
                toastr.warning("Please save the changes.")
                error = true
            }
            if (!error) {
                authService.callAPI(TPWIZARDCONSTANT.API_SAVE_SECTION, "POST", obj, (response) => {
                    if (response.result && response.result) {
                        $state.go('tpActivityPreview', {
                            qpId: $scope.qpId
                        })
                    }
                })
            }
        }
        $scope.routeToCreateQuestion = function() {
            localStorageService.set('academicDetails', academics)
            localStorageService.set("createQuesiton", {
                    state: "tpActivity",
                    qp_id: $scope.qpId,
                    activity_id: activityId,
                    theme_id: localStorageService.get('theme_id'),
                    class_id: academics.class_id,
                    curriculum_id: academics.curriculum_id,
                    subject_id: academics.subject_id,
                    batch_id: academics.batch_id,
                    session_id: academics.session_id,
                    school_id: academics.school_id,
                    practice_qn: $scope.practice_qn,
                    academic_year: localStorageService.get("activeAcdYear"),
                    isQuestionAvailable: true,
                    teaching_plan_id:$scope.planId
                })
            $state.go("createTpQuestion")

        }
        $scope.validateMark = function() {
            if ($scope.markForEach && $scope.markForEach > 100)
                $scope.markForEach = 0
        }
        $scope.addQnMark = function(eachQues) {
            if (eachQues.qn_mark > 0)
                eachQues['qn_mark_error'] = false
        }

        //Added for dragging sections
        //developer - Raziya
        $scope.sortableOptions = {
            containment: '#sortable-container'
        };
        $scope.dragControlListeners = {
            accept: function(sourceItemHandleScope, destSortableScope) {
                return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
            },
            itemMoved: function(event) {
                event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
            },
            orderChanged: function(event) {},
            dragStart: function() {},
            dragEnd: function() {},
            containment: '#board', //optional param.
            containerPositioning: 'relative',
            clone: false, //optional param for clone feature.
            allowDuplicates: false //optional param allows duplicates to be dropped.
        };

    }
}
export default FormatQpController



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/formatQp.js